import { mf, msg } from '../message-functions'

/**
  <span style="color:#85c1dc;">**EE:**</span>
  TOP100

  <span style="color:#85c1dc;">**FI:**</span>
  TOP100

  <span style="color:#85c1dc;">**RU:**</span>
  ТОП100
*/
/* @__NO_SIDE_EFFECTS__ */
const m807 = msg(
  mf`TOP100`,
  mf`TOP100`,
  mf`ТОП100`,
)

export { m807 as 'w.module.product.label_top' }